<template>
    <div>
        <div class="d-flex justify-content-center mb-3">
            <ul class="nav nav-pills">
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'visao' ? 'active' : ''" @click.prevent="abrir('visao')">
                        Visão Geral
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'reembolsos' ? 'active' : ''" @click.prevent="abrir('reembolsos')" >
                        Reembolsos
                    </a>
                </li>
                <li class="nav-item" v-if="origem == 'labs' || origem == 'teste'">
                    <a class="nav-link" href="#" :class="aba == 'login' ? 'active' : ''" @click.prevent="abrir('login')" >
                        Logins Enviados
                    </a>
                </li>
            </ul>
        </div>

        <template v-if="aba == 'login'">
            <login-enviado />
        </template>

        <template v-else>

            <div class="card dashcard mb-0">
                <div class="card-body">
                    <div class="form-row">
                        <div class="col col-12 col-md-6">
                            <az-periodo v-model="filtro" :sync="true" @sync="load(1)" />
                        </div>
                        <div class="col col-12 col-md-2">
                            <az-input
                                type="select" 
                                optionsMode="json"
                                :optionsList="[
                                    { id: 'R', search: 'Referência' },
                                    { id: 'E', search: 'Emissão' },
                                    { id: 'C', search: 'Crédito' },
                                ]"
                                optionsData="id"
                                placeholder="Atendimento"
                                icon="fa fa-calendar-check-o fa-fw" 
                                v-model="filtro.tipo_data" />
                        </div>
                        <div class="col col-12 col-md-2">
                            <az-input
                                icon="far fa-building fa-fw"
                                type="select"
                                placeholder="Unidades..."
                                :optionsList="$util.unidades_com_tags(true, true)"
                                optionsData="id_unidade_operacao"
                                v-model="filtro.id_unidade_operacao" />
                        </div>
                        <div class="col col-12 col-md-2">
                            <az-input
                                icon="fas fa-dollar-sign fa-fw"
                                type="select"
                                placeholder="Todos..."
                                :optionsList="[
                                    { id: 'P', search: 'Com Valor Pago' },
                                    { id: 'D', search: 'Com Desconto' },
                                    { id: 'R', search: 'Com Recurso' },
                                    { id: 'C', search: 'Com Valor Creditado' },
                                    { id: 'I', search: 'Com Inadimplência' },
                                ]"
                                optionsData="id"
                                v-model="filtro.filtro_valor">
                            </az-input>
                        </div>
                    </div>

                    <div class="form-row mt-2">
                        <div class="col col-12 col-md-4">
                            <az-input
                                icon="far fa-credit-card"
                                type="select"
                                optionsMode="aql"
                                optionsData="id_operadora"
                                optionsDisplay="st_operadora"
                                optionsName="operadoras_com_tags.index"
                                :optionsParm="{ 
                                    classes: true 
                                }"
                                service="operadoras.index"
                                placeholder="Todas as Operadoras..."
                                v-model="filtro.id_operadora">
                            </az-input>
                        </div>
                        <div class="col col-12 col-md-2">
                            <az-input
                                icon="fas fa-file-invoice-dollar fa-fw"
                                type="select"
                                placeholder="Nota Fiscal..."
                                :optionsList="[
                                    { id: 'S', search: 'Com NF' },
                                    { id: 'N', search: 'Sem NF' },
                                    { id: 'DI', search: 'Guia Disponível' },
                                    { id: 'FT', search: 'Guia Faturada' },
                                ]"
                                optionsData="id"
                                v-model="filtro.com_nota">
                            </az-input>
                        </div>
                        <div class="col col-12 col-md-2">
                            <az-input
                                icon="fa fa-tags fa-fw"
                                type="select"
                                placeholder="Integração..."
                                :optionsList="[
                                    { id: 'S', search: 'Integrados' },
                                    { id: 'N', search: 'Não Integrados' },
                                ]"
                                optionsData="id"
                                v-model="filtro.integrados">
                            </az-input>
                        </div>
                        <div class="col col-12" :class="aba == 'reembolsos' ? 'col-md-4' : 'col-md-2'">
                            <az-input icon="fas fa-user-md fa-fw" 
                                type="select" 
                                optionsMode="aql"
                                service="medicos.index"
                                optionsName="medicos-reembolso"
                                optionsData="id_pessoa"
                                placeholder="Executantes..."
                                :optionsParm="{ 
                                    ativos: true,
                                    unidade: true 
                                }"
                                v-model="filtro.id_medico" />
                        </div>
                        <div class="col col-12 col-md-2" v-if="aba != 'reembolsos'">
                            <az-input  
                                type="checkbox-group"
                                label="Por Grupo"
                                v-model="filtro.por_grupo" />
                        </div>
                    </div>

                    <div class="form-row mt-2" v-if="aba == 'reembolsos'">
                        <div class="col col-12 col-md-2">
                            <az-input
                                type="select" 
                                optionsMode="json"
                                :optionsList="lista_status"
                                optionsData="id_contato_status"
                                placeholder="Todos os status..."
                                icon="fa fa-filter fa-fw" 
                                v-model="filtro.id_contato_status" />
                        </div>
                        <div class="col col-12 col-md-4">
                            <az-input 
                                v-if="filtro.op_filtro == 'PAC'"
                                placeholder="Selecionar paciente..."
                                type="autocomplete" 
                                optionsMode="aql"
                                service="pacientes.index"
                                optionsDisplay="search"
                                ref="info_paciente"
                                v-model="filtro.paciente" 
                                :optimized_ac="true">
                                <template v-slot:button-pre>
                                    <div class="input-group-prepend">
                                        <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i class="fa-solid fa-user fa-fw" v-if="filtro.op_filtro == 'PAC'"></i>
                                            <i class="fa-solid fa-play fa-fw" v-if="filtro.op_filtro == 'PROC'"></i>
                                        </button>
                                        <div class="dropdown-menu">
                                            <a class="dropdown-item" href="#" @click.prevent="filtro.op_filtro = 'PAC'">
                                                <i class="fa-solid fa-user fa-fw mr-2"></i>
                                                Paciente
                                            </a>
                                            <a class="dropdown-item" href="#" @click.prevent="filtro.op_filtro = 'PROC'">
                                                <i class="fa-solid fa-play fa-fw mr-2"></i>
                                                Procedimento
                                            </a>
                                        </div>
                                    </div>
                                </template>
                            </az-input>

                            <az-input
                                v-else-if="filtro.op_filtro == 'PROC'"
                                placeholder="Todos os procedimentos..."
                                type="autocomplete"
                                service="procedimentos.index"
                                optionsMode="aql"
                                optionsName="procedimentos.index"
                                v-model="filtro.procedimento"
                                ref="info_procedimento">
                                <template v-slot:button-pre>
                                    <div class="input-group-prepend">
                                        <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i class="fa-solid fa-user fa-fw" v-if="filtro.op_filtro == 'PAC'"></i>
                                            <i class="fa-solid fa-play fa-fw" v-if="filtro.op_filtro == 'PROC'"></i>
                                        </button>
                                        <div class="dropdown-menu">
                                            <a class="dropdown-item" href="#" @click.prevent="filtro.op_filtro = 'PAC'">
                                                <i class="fa-solid fa-user fa-fw mr-2"></i>
                                                Paciente
                                            </a>
                                            <a class="dropdown-item" href="#" @click.prevent="filtro.op_filtro = 'PROC'">
                                                <i class="fa-solid fa-play fa-fw mr-2"></i>
                                                Procedimento
                                            </a>
                                        </div>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                        <div class="col col-12 col-md-2">
                            <az-input 
                                placeholder="Ordem de Data"
                                icon="fa-solid fa-arrow-down-short-wide fa-fw"
                                type="select"
                                :optionsList="[
                                    { id: 'A', search: 'Ordem Alfabética' }, 
                                    { id: 'N', search: 'Ordem Número Atend.' }, 
                                    { id: 'V', search: 'Ordem de Valor' }, 
                                ]"
                                optionsData="id"
                                v-model="ordem_items" />
                        </div>
                        <div class="col col-12 col-md-4">
                            <az-input 
                                icon="fa fa-search fa-fw" 
                                placeholder="Pesquisar... Digite # + Número do Atendimento para buscar um específico..."
                                v-model="search">
                                <template v-slot:buttonposb>
                                    <print-export printid="lista-pacientes" :dados="dados_exportacao" :left="true" />
                                </template>
                            </az-input>
                        </div>
                    </div>
                </div>
            </div>

            <div class="progress mt-1 mb-2" v-if="!vazio">
                <div class="indeterminate" v-if="$store.state.loading"></div>
                <div class="determinate" v-else></div>
            </div>    

            <az-empty-state 
                class="mt-3" 
                v-if="vazio" 
                :icon="ja_buscou ? 'far fa-file-alt' : 'fa fa-search'" 
                :msg="ja_buscou ? 'Nenhum item registrado.' : 'Buscar Reembolsos'"
                :action="ja_buscou ? '' : 'Buscar'"
                :method="load" />

            <!-- Lista de items -->
            <template v-else>

                <div v-if="aba == 'visao'">

                    <div class="form-row">
                        <div class="col col-12 col-md-3 mb-2" v-for="(contador, icx) in contadores" :key="icx">
                            <div class="card h-100 mb-0 dashcard">
                                <div class="card-body d-flex justify-content-between py-2" :class="'alert-' + contador.color">
                                    <div>
                                        <div class="lead">
                                            <span v-if="por_grupo">
                                                {{ contador.grupo }}
                                            </span>
                                            <a href="#" @click.prevent="filtrar_status(contador)" class="card-link" v-else>
                                                {{ contador.status }}
                                            </a>
                                        </div>
                                        <div>
                                            {{ $util.formatMoeda(contador.valor_total) }}
                                        </div>
                                        <div class="small font-italic" v-if="contador.valor_creditado">
                                            Creditado: {{ $util.formatMoeda(contador.valor_creditado) }}
                                        </div>
                                        <div class="small" v-if="contador.valor_pago">
                                            Pago: {{ $util.formatMoeda(contador.valor_pago) }}
                                        </div>
                                        <div class="small" v-if="contador.valor_devolvido">
                                            Devolvido: {{ $util.formatMoeda(contador.valor_devolvido) }}
                                        </div>
                                        <div class="small" v-if="contador.valor_juros">
                                            Juros: {{ $util.formatMoeda(contador.valor_juros) }}
                                        </div>
                                        <div class="small" v-if="contador.valor_desconto">
                                            Desconto: {{ $util.formatMoeda(contador.valor_desconto) }}
                                        </div>
                                        <div class="small" v-if="contador.valor_recurso">
                                            Recurso: {{ $util.formatMoeda(contador.valor_recurso) }}
                                        </div>
                                        <div class="small" v-if="contador.valor_inad">
                                            Inad: {{ $util.formatMoeda(contador.valor_inad) }}
                                        </div>
                                    </div>
                                    <div>
                                        <span class="display-4">
                                            {{ contador.qtde }}
                                        </span>
                                        <div v-if="false">
                                            <span class="badge badge-light" title="Pacientes">
                                                P: {{ contador.qt_pacientes }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col col-12 col-md-3 mb-2" v-if="contadores && contadores.length > 1">
                            <div class="card h-100 mb-0 dashcard">
                                <div class="card-body d-flex bg-dark text-white justify-content-between py-2">
                                    <div>
                                        <div class="lead">
                                            <a href="#" @click.prevent="filtrar_status({ id_contato_status: '' })" class="card-link text-white">
                                                Total
                                            </a>
                                        </div>
                                        <div>
                                            {{ $util.formatMoeda(totalizar(contadores, 'valor_total')) }}
                                        </div>
                                        <div class="small font-italic" v-if="totalizar(contadores, 'valor_creditado') > 0">
                                            Creditado: {{ $util.formatMoeda(totalizar(contadores, 'valor_creditado')) }}
                                        </div>
                                        <div class="small" v-if="totalizar(contadores, 'valor_pago') > 0">
                                            Pago: {{ $util.formatMoeda(totalizar(contadores, 'valor_pago')) }}
                                        </div>
                                        <div class="small" v-if="totalizar(contadores, 'valor_juros') > 0">
                                            Juros: {{ $util.formatMoeda(totalizar(contadores, 'valor_juros')) }}
                                        </div>
                                        <div class="small" v-if="totalizar(contadores, 'valor_desconto') > 0">
                                            Desconto: {{ $util.formatMoeda(totalizar(contadores, 'valor_desconto')) }}
                                        </div>
                                        <div class="small" v-if="totalizar(contadores, 'valor_recurso') > 0">
                                            Recurso: {{ $util.formatMoeda(totalizar(contadores, 'valor_recurso')) }}
                                        </div>
                                        <div class="small" v-if="totalizar(contadores, 'valor_inad') > 0">
                                            Inad: {{ $util.formatMoeda(totalizar(contadores, 'valor_inad')) }}
                                        </div>
                                    </div>
                                    <div>
                                        <div class="display-4">
                                            {{ totalizar(contadores, 'qtde') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Gráficos -->

                    <div class="form-row mt-3">
                        <div class="col col-12 col-md-6">
                            <div class="card carde">
                                <div class="card-header bg-dark text-white">
                                    <strong>Status Valor</strong>
                                </div>
                                <div class="card-body">
                                    <Chart 
                                        type="horizontalBar" 
                                        :data="info_grafico('valor_total')"
                                        :options="graph_options"  />
                                </div>
                            </div>
                        </div>

                        <div class="col col-12 col-md-6">
                            <div class="card carde">
                                <div class="card-header bg-dark text-white">
                                    <strong>Status Valor</strong>
                                </div>
                                <div class="card-body">
                                    <Chart 
                                        type="pie" 
                                        :data="info_grafico('valor_total')"
                                        :options="graph_options"  />
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="form-row mt-3">

                        <div class="col col-12 col-md-6">
                            <div class="card carde">
                                <div class="card-header bg-dark text-white">
                                    <strong>Status Quantidade</strong>
                                </div>
                                <div class="card-body">
                                    <Chart 
                                        type="horizontalBar" 
                                        :data="info_grafico('qtde')"
                                        :options="graph_options"  />
                                </div>
                            </div>
                        </div>

                        <div class="col col-12 col-md-6">
                            <div class="card carde">
                                <div class="card-header bg-dark text-white">
                                    <strong>Status Quantidade</strong>
                                </div>
                                <div class="card-body">
                                    <Chart 
                                        type="pie" 
                                        :data="info_grafico('qtde')"
                                        :options="graph_options"  />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div v-if="aba == 'reembolsos'">
                    <div class="d-flex justify-content-between">
                        <div>
                            <div class="badge badge-secondary mb-2 d-print-none">
                                {{ dados.from }} - {{ dados.to }} / {{ dados.total }}
                            </div>
                        </div>

                        <div>
                            <button type="button" class="btn btn-outline-primary" title="Registrar status em lote." @click="abrir_contatos()" v-if="pode_lote">
                                <i class="fa-solid fa-comments"></i>
                            </button>
                        </div>
                    </div>

                    <pre v-if="false">{{ lista }}</pre>
                </div>

                <div id="lista-pacientes" v-if="aba == 'reembolsos'" class="mb-3 mx-3">
                    <cabecalho-generico titulo="Reembolso">
                    </cabecalho-generico>

                    <div>
                        <div class="row my-2 py-1 dashcard align-items-center w3-animate-opacity" :class="'alert-' + cor_item(item)" v-for="(item, index) in lista" :key="index">
                            <!-- Ação -->
                            <div class="col-12 col-md-2 col-lg-2 my-2 my-md-auto">
                                <div class2="d-flex flex-column">
                                    <div class="text-nowrap text-truncate">
                                        <button type="button" class="btn btn-primary btn-sm mr-2 mb-1 d-print-none"
                                            data-toggle="tooltip" data-placement="top" title="Editar"
                                            @click="abrir_contatos (item)">
                                            <i class="fas fa-comments"></i>
                                        </button>

                                        <span>

                                            <span class="badge badge-dark ml-1">
                                                {{ item.contatos.length }}
                                            </span>

                                            <div>

                                                <a href="#" @click.prevent="filtrar_status(item.contatos.length ? item.contatos[0] : null)">
                                                    <span class="badge" :class="( item.contatos.length && item.contatos[0].contato_status.st_color ) ? 'badge-' + item.contatos[0].contato_status.st_color : 'badge-secondary'">
                                                        <span v-if="item.contatos.length">
                                                            {{ item.contatos[0].contato_status.search }}
                                                        </span>
                                                        <span v-else>
                                                            Registrado
                                                        </span>
                                                    </span>
                                                </a>

                                            </div>

                                        </span>

                                    </div>
                                </div>
                            </div>

                            <!-- Data -->
                            <div class="col col-12 col-md-2"> 
                                <div>
                                    <a href="#" @click.prevent="abrir_atendimento(item)">
                                        #{{ item.id_atendimento }}
                                    </a>

                                    <a href="#" @click.prevent="imprimir_nf(item)" class="ml-3"
                                        v-if="item.marcacao 
                                            && item.marcacao.atendimento 
                                            && item.marcacao.atendimento.nota_fiscal_link 
                                            && item.marcacao.atendimento.nota_fiscal_link.nota_fiscal_servico 
                                            && item.marcacao.atendimento.nota_fiscal_link.nota_fiscal_servico.ch_status != 5">
                                        {{ item.marcacao.atendimento.nota_fiscal_link.nota_fiscal_servico.numero_completo }}
                                    </a>
                                </div>
                                <div>
                                    <i class="fa fa-play text-muted fa-fw mr-2" aria-hidden="true" title="Data de Atendimento"></i>
                                    {{ $util.getFormatDate(item.dt_inicio) }} {{ item.dt_inicio.substr(11,5) }}
                                </div>
                                <div v-if="item.contatos && item.contatos.length && item.contatos[0].dt_referencia">
                                    <i class="fa fa-calendar-check-o fa-fw mr-2" aria-hidden="true" title="Data de Referência"></i>
                                    {{ $util.getFormatDate(item.contatos[0].dt_referencia) }}
                                </div>
                                <div v-for="(guia, igx) in item.guias" :key="igx">
                                    <a href="#" @click.prevent="editar_guia(item, guia)" class="card-link">
                                        <i class="far fa-file-alt fa-fw mr-2" title="Guia"></i>
                                        <span class="badge mr-1" :class="'badge-' + ( guia.status_color ? guia.status_color : 'secondary' )" :title="guia.status_guia">
                                            {{ guia.ch_status }}
                                        </span>
                                        {{ guia.st_numero_interno }} 
                                        <span v-if="guia.st_numero">/ {{ guia.st_numero }}</span>
                                    </a>
                                </div>
                            </div>
                            <!-- Identificação do Paciente -->
                            <div class="col col-12 col-md-4">
                                <celula-dados-paciente :hor="{ marcacao: item }">
                                    <template v-slot:plano>
                                        <a href="#" @click.prevent="abrir_anexar_arquivo(item, 'solicitacaoAutorizacao')" class="card-link m-0" v-if="item.marcacao && item.marcacao.autorizacao && item.marcacao.autorizacao.arquivos">
                                            <span data-toggle2="tooltip" data-placement="top" title="Anexar Arquivos">
                                                <i class="fa fa-paperclip ml-2" aria-hidden="true" v-if="item.marcacao.autorizacao.arquivos.length"></i>
                                                <i class="fas fa-plus ml-2" v-else></i>
                                            </span>
                                        </a>
                                    </template>
                                </celula-dados-paciente>
                            </div>

                            <div class="col col-12 col-md-4 d-flex justify-content-between">
                                <div>
                                    <celula-dados-procedimento :hor="{ marcacao: item.marcacao, total_items: item.total_items }" @abriranexos="abrir_anexar_arquivo(item)">
                                        <template v-slot:pos-valor>
                                            <a href="#" @click.prevent="editar_valor(item)" class="card-link mr-2" 
                                                :class="item.reembolso ? '' : 'text-secondary'"
                                                v-if="item.contatos.length">
                                                <i class="fas fa-edit"></i>
                                            </a>
                                            <span class="small text-muted font-italic" v-if="item.reembolso && item.reembolso.dc_valor_creditado">
                                                Creditado: {{ $util.formatMoeda(item.reembolso.dc_valor_creditado) }}
                                                <span v-if="item.reembolso.dt_creditado" class="ml-1">
                                                    / em {{ $util.getFormatDate(item.reembolso.dt_creditado) }}
                                                </span>
                                            </span>
                                            <div class="small text-muted" v-if="item.reembolso && item.reembolso.dc_valor_pago">
                                                Pago: {{ $util.formatMoeda(item.reembolso.dc_valor_pago - ( item.reembolso.dc_valor_devolvido ? item.reembolso.dc_valor_devolvido : 0 )) }}
                                                <span v-if="item.reembolso.dc_valor_devolvido">
                                                    / Devol: {{ $util.formatMoeda(item.reembolso.dc_valor_devolvido) }}
                                                </span>
                                                <span v-if="item.reembolso.dc_valor_juros">
                                                    / Juros: {{ $util.formatMoeda(item.reembolso.dc_valor_juros) }}
                                                </span>
                                                <span v-if="item.reembolso.dc_valor_desconto">
                                                    / Desc: {{ $util.formatMoeda(item.reembolso.dc_valor_desconto) }}
                                                </span>
                                                <span v-if="item.reembolso.dc_valor_recurso">
                                                    / Rec: {{ $util.formatMoeda(item.reembolso.dc_valor_recurso) }}
                                                </span>
                                                <span v-if="item.reembolso.dc_valor_inadimplente">
                                                    / Inad: {{ $util.formatMoeda(item.reembolso.dc_valor_inadimplente) }}
                                                </span>
                                            </div>
                                            <div class="small text-muted" v-else-if="item.reembolso">
                                                <span v-if="item.reembolso.dc_valor_recurso">
                                                    Rec: {{ $util.formatMoeda(item.reembolso.dc_valor_recurso) }}
                                                </span>
                                                <span v-if="item.reembolso.dc_valor_inadimplente">
                                                    / Inad: {{ $util.formatMoeda(item.reembolso.dc_valor_inadimplente) }}
                                                </span>
                                            </div>
                                        </template>
                                    </celula-dados-procedimento>
                                </div>

                                <!-- Menu de opções -->
                                <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2">
                                    <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-ellipsis-v"></i>
                                    </a>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">

                                        <template v-if="item.paciente && item.paciente.arquivos">

                                            <button class="dropdown-item" @click="abrir_anexar_arquivo(item, 'pessoa')">
                                                <i class="fa fa-paperclip fa-fw mr-2" aria-hidden="true" v-if="item.paciente && item.paciente.arquivos && item.paciente.arquivos.length"></i>
                                                <i class="fas fa-plus fa-fw mr-2" v-else></i>
                                                Arquivos do Paciente
                                            </button>

                                            <div class="dropdown-divider"></div>

                                        </template>

                                        <template v-if="item.marcacao && item.marcacao.atendimento">

                                            <button class="dropdown-item" @click="imprimir_espelho(item)">
                                                <i class="far fa-file-alt fa-fw mr-2"></i>
                                                Espelho de Atendimento
                                            </button>

                                            <button class="dropdown-item" @click="enviar_espelho(item)">
                                                <i class="far fa-envelope-open fa-fw mr-2"></i>
                                                Enviar Espelho por E-mail
                                            </button>

                                        </template>

                                        <template v-if="item.id_reembolso">
                                            <button class="dropdown-item" @click="$util.logAudit('reembolso', item.id_reembolso);">
                                                <i class="fa-solid fa-circle-info fa-fw mr-2"></i>
                                                Log de Alterações
                                            </button>
                                        </template>

                                        <button class="dropdown-item" v-if="item.marcacao && item.marcacao.atendimento && item.marcacao.atendimento.nota_fiscal_link 
                                                && item.marcacao.atendimento.nota_fiscal_link.nota_fiscal_servico && item.marcacao.atendimento.nota_fiscal_link.nota_fiscal_servico.ch_status == 4" 
                                                @click="imprimir_nf(item)">
                                            <i class="fas fa-file-invoice-dollar fa-fw mr-2"></i>
                                            Nota Fiscal
                                        </button>

                                        <button class="dropdown-item" @click="verificar_status_rpa(item)" 
                                            v-if="item.marcacao 
                                                && item.plano 
                                                && item.plano.operadora.st_registro_ans == '005711' 
                                                && $store.state.user.id_usuario == 1">
                                            <i class="fa-solid fa-robot fa-fw mr-2"></i>
                                            Verificar Status
                                        </button>

                                        <template v-if="item.marcacao && item.marcacao.st_id_externo && item.marcacao.st_id_externo.indexOf(':') > 0">
                                            <div class="dropdown-divider"></div>
                                            <button class="dropdown-item" @click="integrar_agenda_klingo(item)">
                                                <i class="fa-solid fa-tower-cell fa-fw mr-2"></i>
                                                Re-Integrar Processo de Reembolso
                                            </button>
                                            <button class="dropdown-item" @click="integrar_reembolso_klingo(item)">
                                                <i class="fa-solid fa-tower-cell fa-fw mr-2"></i>
                                                Integrar Reembolso
                                            </button>
                                        </template>

                                        <laboratorio-etiqueta v-model="item.marcacao" :dropdown="true">
                                            <template v-slot:dropamostras>
                                                <button class="dropdown-item" v-if="item.marcacao && item.marcacao.atendimento && item.marcacao.atendimento.amostras_count"
                                                    @click="$refs.amostras.abrir(item.marcacao.id_atendimento)">
                                                    <i class="fas fa-vials fa-fw mr-2"></i>
                                                    Amostras
                                                </button>
                                                <button class="dropdown-item" v-if="item.marcacao && item.marcacao.atendimento && item.marcacao.atendimento.amostras_count"
                                                    @click="$refs.integra.abrir(item.marcacao)">
                                                    <i class="fas fa-tasks fa-fw mr-2"></i>
                                                    Verificar Integração
                                                </button>
                                                
                                            </template>
                                        </laboratorio-etiqueta>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <button type="button" class="btn btn-sm btn-outline-primary mt-3" v-if="$store.state.user.id_usuario == 1 && tem_integrado" @click="integrar_reembolsos_klingo()" :disabled="$store.state.loading">
                        Integrar Reembolsos
                    </button>
                </div>

            </template>

            <template v-if="false">
                <pre v-if="lista.length">{{ lista }}</pre>
            </template>

            <br><br><br><br><br><br><br><br><br><br>

            <!-- Paginação -->
            <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="dados && dados.last_page > 1">
                <div class="d-flex">
                    <paginate
                        class="mb-0"
                        :page-count="dados.last_page"
                        :container-class="'pagination'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :prev-class="'page-link'"
                        :next-class="'page-link'"
                        :prev-text="'<<'"
                        :next-text="'>>'"
                        :click-handler="paginar">
                    </paginate>
                </div>
            </nav>

            <registrar-contatos 
                :lista_status="lista_status_edicao" 
                :block_origem="lista_status_block_edicao"
                :extra_parms="{ reembolso: true }"
                ref="regcontatos" 
                @refresh="load()">
                <template v-slot:info>
                    <template v-if="edicao && !edicao.lote">
                        <div class="alert alert-secondary lead d-flex justify-content-between">
                            <div>
                                Total: {{ $util.formatMoeda(total_edicao) }}
                            </div>
                            <div v-if="edicao.marcacao && edicao.marcacao.st_id_externo">
                                {{ edicao.marcacao.st_id_externo }}
                            </div>
                        </div>

                        <div v-if="edicao.paciente && edicao.paciente.login_reembolso">
                            <az-input
                                class="mb-3"
                                sizing="sm"
                                label="Login"
                                :edicao="false"
                                v-model="edicao.paciente.login_reembolso.st_login" />    

                            <az-input
                                :type="exibir_senha ? 'text' : 'password'"
                                class="mb-3"
                                sizing="sm"
                                label="Senha"
                                :edicao="false"
                                v-model="edicao.paciente.login_reembolso.st_senha">    
                                <template v-slot:buttonposb>
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="exibir_senha = !exibir_senha">
                                            <i class="fa fa-eye-slash fa-fw" aria-hidden="true" v-if="!exibir_senha"></i>
                                            <i class="fa fa-eye fa-fw" aria-hidden="true" v-else></i>
                                        </button>
                                    </div>
                                </template>
                            </az-input>
                        </div>
                        <az-input
                            class="mb-3"
                            sizing="sm"
                            label="Matrícula"
                            :edicao="false"
                            v-model="edicao.st_numero_carteira">
                            <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="is_labs && $store.state.user.id_usuario == 1">
                                    <az-submit color="outline-primary" :hide_content_while_loading="true" title="Verificar Status" @click="verificar_status(edicao)">
                                        <i class="fas fa-search-dollar fa-fw"></i>
                                    </az-submit>
                                </div>
                            </template>
                        </az-input>

                        <pre class="alert alert-info" v-if="edicao.rpa_status">{{ edicao.rpa_status }}</pre>

                        <div class="mb-3" v-if="edicao.guias && edicao.guias.length">
                            <div v-for="(guia, igx) in edicao.guias" :key="igx">
                                <i class="far fa-file-alt fa-fw mr-2" title="Guia"></i>
                                <span class="badge badge-secondary mr-1">{{ guia.ch_status }}</span>
                                {{ guia.st_numero_interno }} 
                                <span v-if="guia.st_numero">/ {{ guia.st_numero }}</span>
                            </div>
                        </div>

                        <table class="table table-sm table-hover">
                            <thead>
                                <tr>
                                    <th>Descrição</th>
                                    <th class="text-right">Valor</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(atp, iax) in edicao.atendimento_procedimentos" :key="iax" class="small">
                                    <td>
                                        {{ atp.procedimento.search }}
                                        <span class="badge badge-light" v-if="atp.in_quantidade > 1">
                                            x{{ atp.in_quantidade }}
                                        </span>
                                    </td>
                                    <td class="text-right">{{ $util.formatMoeda(atp.cd_valor_total) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                </template>
            </registrar-contatos>

            <!-- Envio de Arquivo -->
            <template v-if="acao_anexar && edicao && edicao.marcacao">
                <az-file-upload
                    ref="upload"
                    @refresh="carregar_arquivos()"
                    :multiple="true"
                    :arquivos="model_arquivos.arquivos"
                    :parms="{ model_type: model_type, model_id: model_id }" />
            </template>   

            <!-- Modal -->
            <div class="modal fade" id="edicaoGuiaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
                <div class="modal-dialog modal-dialog-scrollable" role="document">
                    <div class="modal-content" v-if="edicao_guia">
                        <div class="modal-header">
                            <h5 class="modal-title">Editar Guia</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <celula-dados-paciente :hor="{ marcacao: edicao_guia.item }" />

                            <hr>

                            <template v-if="!edicao_guia.guia">
                                <az-empty-state />
                            </template>

                            <template v-else>

                                <div class="d-flex justify-content-between">
                                    <span class="h5 badge badge-secondary">
                                        #{{ edicao_guia.item.id_atendimento }}
                                    </span>

                                    <span class="h5 badge" :class="'badge-' + ( edicao_guia.guia.status_color ? edicao_guia.guia.status_color : 'secondary' )">
                                        {{ edicao_guia.guia.ch_status }}
                                    </span>
                                </div>

                                <div class="row mt-3">
                                    <div class="col col-12">
                                        <az-input 
                                            label="Nota Fiscal"
                                            v-model="edicao_guia.guia.st_numero_interno" />
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col col-12">
                                        <az-input 
                                            label="Protocolo"
                                            v-model="edicao_guia.guia.st_numero" />
                                    </div>
                                </div>

                                <template v-if="edicao_guia.guia.ch_status == 'FT'">

                                    <ul class="list-group mt-3">
                                        <template v-if="edicao_guia.guia.guia_fatura 
                                            && edicao_guia.guia.guia_fatura.fatura 
                                            && edicao_guia.guia.guia_fatura.fatura.fatura_envio
                                            && edicao_guia.guia.guia_fatura.fatura.fatura_envio.lancamento">
                                            <li class="list-group-item d-flex justify-content-between">
                                                <div>
                                                    <div>
                                                        Lançamento #{{ edicao_guia.guia.guia_fatura.fatura.fatura_envio.id_lancamento }}
                                                        / {{ $util.formatMoeda(edicao_guia.guia.guia_fatura.fatura.fatura_envio.lancamento.dc_valor) }}
                                                    </div>
                                                    <div> 
                                                        <span v-if="edicao_guia.guia.guia_fatura.fatura.fatura_envio.lancamento.forma_pagamento" class="small text-muted mr-3">
                                                            {{ edicao_guia.guia.guia_fatura.fatura.fatura_envio.lancamento.forma_pagamento.search }}
                                                        </span>
                                                        <span v-if="edicao_guia.guia.guia_fatura.fatura.fatura_envio.lancamento.categoria" class="small text-muted">
                                                            {{ edicao_guia.guia.guia_fatura.fatura.fatura_envio.lancamento.categoria.search }}
                                                        </span>
                                                    </div>
                                                    <div v-if="edicao_guia.guia.guia_fatura.fatura.fatura_envio.dt_envio && edicao_guia.guia.guia_fatura.fatura.fatura_envio.dt_envio.slice(0,10) != edicao_guia.guia.guia_fatura.fatura.fatura_envio.lancamento.dt_emissao">
                                                        Registro {{ $util.getFormatDate(edicao_guia.guia.guia_fatura.fatura.fatura_envio.dt_envio) }}
                                                    </div>
                                                    <div>
                                                        Emissão {{ $util.getFormatDate(edicao_guia.guia.guia_fatura.fatura.fatura_envio.lancamento.dt_emissao) }}
                                                    </div>
                                                    <div>
                                                        Vencimento {{ $util.getFormatDate(edicao_guia.guia.guia_fatura.fatura.fatura_envio.lancamento.dt_vencimento) }}
                                                    </div>
                                                </div>
                                                <div v-if="!edicao_guia.guia.guia_fatura.fatura.fatura_envio.lancamento.baixas.length">
                                                    <a href="#" @click.prevent="cancelar_lancamento()">
                                                        <i class="fa fa-trash text-danger" aria-hidden="true"></i>
                                                    </a>
                                                </div>
                                            </li>
                                            <li class="list-group-item list-group-item-secondary small">
                                                {{ edicao_guia.guia.guia_fatura.fatura.fatura_envio.lancamento.st_observacoes }}
                                            </li>
                                        </template>
                                        <li class="list-group-item">
                                            <a href="#" @click.prevent="$util.abrirFatura(edicao_guia.guia.guia_fatura.id_fatura)" class="card-link">
                                                Fatura #{{ edicao_guia.guia.guia_fatura.id_fatura }}
                                            </a>
                                        </li>
                                    </ul>

                                </template>

                                <template v-else-if="( edicao_guia.item.fl_reembolso == 2 ) && edicao_guia.guia.st_numero && edicao_guia.guia.ch_status == 'DI'">
                                    <div class="row mt-3" v-if="edicao_guia.guia.st_numero && edicao_guia.guia.ch_status == 'DI'">
                                        <div class="col col-12">
                                            <az-input
                                                type="checkbox-group"
                                                label="Gerar lançamento no contas a receber" 
                                                v-model="edicao_guia.guia.gerar_lanc" />
                                        </div>
                                    </div>

                                    <template v-if="edicao_guia.guia.gerar_lanc">
                                        <div class="row">
                                            <div class="col col-12 col-md-6">
                                                <az-input   
                                                    sizing="sm"
                                                    label="Emissão"
                                                    type="date"
                                                    required
                                                    :validate="validate"
                                                    v-model="edicao_guia.guia.dt_emissao_lanc" />
                                            </div>
                                            <div class="col col-12 col-md-6">
                                                <az-input   
                                                    sizing="sm" 
                                                    label="Vencimento"
                                                    type="date"
                                                    required
                                                    :validate="validate"
                                                    v-model="edicao_guia.guia.dt_vencimento" />
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col col-12">
                                                <az-input
                                                    sizing="sm"
                                                    label="Categoria"
                                                    required
                                                    :validate="validate"
                                                    type="select"
                                                    optionsMode="aql"
                                                    service="categorias.index"
                                                    :optionsName="'categorias.C'"
                                                    optionsData="id_categoria"
                                                    optionsDisplay="search"
                                                    :optionsParm="{ lancamento: true, where: { ch_natureza: 'C' } }"
                                                    v-model="edicao_guia.guia.categoria" />
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col col-12">
                                                <az-input
                                                    sizing="sm"
                                                    label="Forma de Pagamento"
                                                    :validate="validate"
                                                    type="select"
                                                    optionsMode="aql"
                                                    service="forma_pagamentos.index"
                                                    optionsData="id_forma_pagamento"
                                                    optionsDisplay="search"
                                                    v-model="edicao_guia.guia.id_forma_pagamento" />
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col col-12">
                                                <az-input
                                                    sizing="sm"
                                                    label="Observação"
                                                    type="textarea"
                                                    rows="2"
                                                    v-model="edicao_guia.guia.lanc_observacao" />
                                            </div>
                                        </div>
                                    </template>
                                </template>

                                <!-- Emissão de Nota Fiscal Eletrônica -->
                                <template v-if="nfl">

                                    <hr> 

                                    <az-sub-title title="Nota Fiscal" />
                                    <div class="list-group mb-3">
                                        <div class="list-group-item d-flex">
                                            <span class="mr-3">{{ $util.getFormatDate(nfl.nota_fiscal_servico.dt_emissao) }}</span>
                                            <span class="mr-3 text-warning" v-if="nfl.nota_fiscal_servico.dt_competencia && !is_mes_atual(nfl.nota_fiscal_servico)">{{ $util.getFormatDate(nfl.nota_fiscal_servico.dt_competencia, "MM/YYYY", false)}}</span>
                                            <span class="mr-3">{{ nfl.nota_fiscal_servico.numero_completo }}</span>
                                            <span class="mr-3">{{ nfl.nota_fiscal_servico.st_tomador_nome }}</span>
                                            <span class="mr-3" :class="getStatusClass(nfl.nota_fiscal_servico.ch_status)">{{ nfl.nota_fiscal_servico.descricao_status }}</span>
                                            <span class="mr-3"
                                                v-if="edicao_guia.item.marcacao && 
                                                    edicao_guia.item.marcacao.unidade_operacao &&
                                                    edicao_guia.item.marcacao.unidade_operacao.fl_nota_fiscal_eletronica">
                                                <nota-fiscal-status
                                                    :exibirEditar="false"
                                                    :notaFiscal="nfl.nota_fiscal_servico"
                                                    @refresh="load()"
                                                />
                                            </span>
                                        </div>
                                    </div>

                                    <!-- 
                                    <button class="btn btn-outline-primary mb-2" @click.prevent="gerarNF()" :disabled="$store.state.loading">
                                        {{ (listaNf && listaNf.length == 0 ) ? 'Emitir Nota Fiscal' : 'Regerar Nota Fiscal' }}
                                    </button>

                                    <template v-if="possuiNF  && (listaNf && listaNf.length > 0 )">
                                        <az-sub-title title="Notas fiscais" />

                                        <div class="list-group mb-3">
                                            <div class="list-group-item d-flex" v-for="(nfl, idx) in listaNf" :key="idx">
                                                <span class="mr-3">{{ $util.getFormatDate(nfl.nota_fiscal_servico.dt_emissao) }}</span>
                                                <span class="mr-3">{{ nfl.nota_fiscal_servico.numero_completo }}</span>
                                                <span class="mr-3" :class="getStatusClass(nfl.nota_fiscal_servico.ch_status)">{{ nfl.nota_fiscal_servico.descricao_status }}</span>
                                                <span class="mr-3"
                                                    v-if="edicao_guia.item.marcacao && 
                                                        edicao_guia.item.marcacao.unidade_operacao &&
                                                        edicao_guia.item.marcacao.unidade_operacao.fl_nota_fiscal_eletronica">
                                                    <nota-fiscal-status
                                                        :exibirEditar="false"
                                                        :notaFiscal="nfl.nota_fiscal_servico"
                                                        @refresh="load()"
                                                    />
                                                </span>
                                            </div>
                                        </div>
                                    </template>
                                    -->
                                </template>

                                <!-- Fim Nota Fiscal -->

                            </template>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                            <az-submit v-if="edicao_guia && edicao_guia.guia" @click="atualizar_guia()">Atualizar</az-submit>
                        </div>
                    </div>
                </div>
            </div>  

            <!-- Modal Valor Reembolso -->
            <div class="modal fade" id="valorReembolsoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
                <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Valor do Reembolso</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body" v-if="edicao_valor">

                            <div class="card">
                                <div class="card-body">
                                    <celula-dados-paciente :hor="{ marcacao: edicao_valor }" />
                                    <hr>
                                    <celula-dados-procedimento :hor="{ marcacao: edicao_valor.marcacao, total_items: edicao_valor.total_items }" :blockanexos="true" />
                                </div>
                            </div>

                            <div v-if="( edicao_valor.fl_reembolso == 2 || edicao_valor.fl_reembolso == 3 ) && edicao_valor.guia && edicao_valor.guia.ch_status == 'FT' && edicao_valor.lancamento">

                                <div class="form-row mb-3">
                                    <div class="col col-12 col-md-3">
                                        <az-input   
                                            type="money"
                                            sizing="sm"
                                            label="Creditado"
                                            v-model="edicao_valor.reembolso.dc_valor_creditado" />
                                    </div>

                                    <div class="col col-12 col-md-3">
                                        <az-input   
                                            type="date"
                                            sizing="sm"
                                            label="Data do Crédito"
                                            v-if="edicao_valor.reembolso.dc_valor_creditado > 0"
                                            v-model="edicao_valor.reembolso.dt_creditado" />
                                    </div>

                                    <div class="col col-12 col-md-3">
                                        <az-input   
                                            type="money"
                                            sizing="sm"
                                            label="Inadimplência"
                                            v-model="edicao_valor.reembolso.dc_valor_inadimplente" />
                                    </div>

                                    <div class="col col-12 col-md-3">
                                        <az-input   
                                            v-if="edicao_valor.lancamento && edicao_valor.lancamento.baixas"
                                            type="money"
                                            sizing="sm"
                                            label="Recurso"
                                            :edicao="!edicao_valor.lancamento.baixas.length"
                                            v-model="edicao_valor.reembolso.dc_valor_recurso" />
                                    </div>
                                </div>

                                <table class="table table-hover small mb-0">
                                    <thead>
                                        <tr class="table-primary">
                                            <th>Descrição</th>
                                            <th>No.</th>
                                            <th>Data</th>
                                            <th>Conta</th>
                                            <th class="text-right">Recebido</th>
                                            <th class="text-right">Desconto</th>
                                            <th class="text-right">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="table-success">
                                            <td>Lançamento</td>
                                            <td>
                                                #{{ edicao_valor.lancamento.id_lancamento }}
                                            </td>
                                            <td>{{ $util.getFormatDate(edicao_valor.lancamento.dt_emissao) }}</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td class="text-right">
                                                {{ $util.formatMoeda(edicao_valor.lancamento.dc_valor) }}
                                                <i class="fa fa-plus-circle text-success ml-1" aria-hidden="true"></i>
                                            </td>
                                        </tr>
                                        <tr v-for="(baixa, ibx) in edicao_valor.lancamento.baixas" :key="ibx">
                                            <td>
                                                <a href="#" @click.prevent="cancelar_baixa(baixa)" class="card-link mr-2"> 
                                                    <i class="fa fa-trash text-danger" aria-hidden="true"></i>
                                                </a>
                                                Baixa
                                            </td>
                                            <td>
                                                #{{ baixa.id_baixa }}
                                            </td>
                                            <td>
                                                {{ $util.getFormatDate(baixa.dt_baixa) }}
                                            </td>
                                            <td>
                                                {{ baixa.conta.search }}
                                                <span v-if="baixa.forma_pagamento && baixa.id_forma_pagamento > 1" class="text-muted ml-3">
                                                    {{ baixa.forma_pagamento.search }}
                                                </span>
                                            </td>
                                            <td class="text-right">
                                                {{ $util.formatMoeda(baixa.valor_liquido) }}
                                            </td>
                                            <td class="text-right">
                                                {{ $util.formatMoeda(baixa.dc_descontos) }}
                                            </td>
                                            <td class="text-right">
                                                {{ $util.formatMoeda(baixa.dc_valor) }}
                                                <i class="fa fa-minus-circle text-danger ml-1" aria-hidden="true"></i>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr class="table-info">
                                            <td colspan="4">Saldo</td>
                                            <td class="text-right">{{ $util.formatMoeda(edicao_valor.lancamento.baixado.liquido) }}</td>
                                            <td class="text-right">{{ $util.formatMoeda(edicao_valor.lancamento.baixado.descontos) }}</td>
                                            <td class="text-right">
                                                {{ $util.formatMoeda(edicao_valor.lancamento.baixado.saldo) }}
                                                <i class="fa fa-circle text-primary ml-1" aria-hidden="true"></i>
                                            </td>
                                        </tr>
                                        <template v-if="edicao_valor.guia && edicao_valor.guia.reembolso && edicao_valor.guia.reembolso.recorrencia && edicao_valor.guia.reembolso.recorrencia.lancamentos">
                                            <tr class="table-danger" v-for="(devol, idx) in edicao_valor.guia.reembolso.recorrencia.lancamentos" :key="idx">
                                                <td>Devolução</td>
                                                <td>
                                                    <a href="#" @click.prevent="editar_lancamento(devol)" class="card-link">
                                                        #{{ devol.id_lancamento }}
                                                    </a>
                                                </td>
                                                <td>{{ $util.getFormatDate(devol.dt_emissao) }}</td>
                                                <td></td>
                                                <td class="text-right">{{ $util.formatMoeda(devol.liquido * -1) }}</td>
                                                <td class="text-right"></td>
                                                <td class="text-right"></td>
                                            </tr>
                                        </template>
                                    </tfoot>
                                </table>

                                <button type="button" class="btn btn-sm btn-outline-danger mt-3 mr-2" @click="registrar_devolucao(edicao_valor)" 
                                    v-if="!edicao_valor.registrar_nova_baixa && edicao_valor.lancamento.baixado.liquido > 0">
                                    <i class="fa-solid fa-hand-holding-dollar mr-2"></i>
                                    Realizar Devolução
                                </button>

                                <button type="button" class="btn btn-sm btn-primary mt-3" @click="edicao_valor.registrar_nova_baixa = !edicao_valor.registrar_nova_baixa" 
                                    v-if="!edicao_valor.registrar_nova_baixa && edicao_valor.lancamento.baixado.saldo > 0">
                                    <i class="fas fa-plus mr-2"></i>
                                    Registrar Pagamento
                                </button>

                                <template v-if="edicao_valor.registrar_nova_baixa">
                                    <az-sub-title 
                                        class="mt-2"
                                        title="Registrar Pagamento" />

                                    <div class="form-row">
                                        <div class="col col-12 col-md-2">
                                            <az-input   
                                                type="date"
                                                sizing="sm"
                                                label="Data"
                                                v-model="edicao_valor.nova_baixa.dt_baixa" />
                                        </div>
                                        <div class="col col-12 col-md-4">
                                            <az-input
                                                sizing="sm"
                                                label="Forma de Pagamento"
                                                :validate="validate"
                                                type="select"
                                                optionsMode="aql"
                                                service="forma_pagamentos.index"
                                                optionsData="id_forma_pagamento"
                                                optionsDisplay="search"
                                                v-model="edicao_valor.nova_baixa.id_forma_pagamento" />
                                        </div>
                                        <div class="col col-12 col-md-6">
                                            <az-input
                                                sizing="sm"
                                                placeholder="Selecione a Conta..."
                                                label="Conta"
                                                type="select"
                                                optionsMode="aql"
                                                service="contas.index"
                                                optionsData="id_conta"
                                                optionsDisplay="search"
                                                :optionsParm="{ ativas: true }"
                                                v-model="edicao_valor.nova_baixa.id_conta" />
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col col-12 col-md-2">
                                            <az-input   
                                                type="money"
                                                sizing="sm"
                                                label="Pago"
                                                v-model="edicao_valor.nova_baixa.dc_valor">
                                                <template v-slot:buttonposb>

                                                </template>
                                            </az-input>
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            <az-input   
                                                type="money"
                                                sizing="sm"
                                                label="Desconto"
                                                v-model="edicao_valor.nova_baixa.dc_descontos" />
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            <az-input   
                                                type="money"
                                                sizing="sm"
                                                label="Multa/Juros"
                                                v-model="edicao_valor.nova_baixa.dc_multa_juros" />
                                        </div>
                                        <div class="col col-12 col-md-3">
                                            <az-input   
                                                type="text"
                                                sizing="sm"
                                                label="Total"
                                                :value="$util.formatMoeda(edicao_valor.nova_baixa.dc_valor + edicao_valor.nova_baixa.dc_descontos + edicao_valor.nova_baixa.dc_multa_juros)" />
                                        </div>                                       
                                        <div class="col col-12 col-md-3">
                                            <az-input   
                                                type="text"
                                                sizing="sm"
                                                label="Saldo"
                                                :value="$util.formatMoeda(edicao_valor.lancamento.baixado.saldo - ( edicao_valor.nova_baixa.dc_valor + edicao_valor.nova_baixa.dc_descontos ))" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col col-12">
                                            <az-input   
                                                label="Observações"
                                                type="textarea"
                                                rows="3"
                                                v-model="edicao_valor.nova_baixa.st_observacoes" />
                                        </div>
                                    </div>
                                </template>

                                <pre v-if="false">{{ edicao_valor.guia }}</pre>
                            </div>

                            <div class="mb-3" v-else>

                                <div class="form-row mb-3">
                                    <div class="col col-12 col-md-3">
                                        <az-input   
                                            type="money"
                                            sizing="sm"
                                            label="Creditado"
                                            v-model="edicao_valor.reembolso.dc_valor_creditado" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input   
                                            type="date"
                                            sizing="sm"
                                            label="Data do Crédito"
                                            v-if="edicao_valor.reembolso.dc_valor_creditado > 0"
                                            v-model="edicao_valor.reembolso.dt_creditado" />
                                    </div>
                                </div>

                                <az-input
                                    type="checkbox-group"
                                    sizing="sm"
                                    label="Pago"
                                    v-model="edicao_valor.reembolso.pago" />

                                <template v-if="edicao_valor.reembolso.pago">

                                    <div class="form-row">
                                        <div class="col col-12 col-md-6">
                                            <az-input   
                                                type="date"
                                                sizing="sm"
                                                label="Data"
                                                required
                                                :validate="validate"
                                                v-model="edicao_valor.reembolso.dt_pagamento" />
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col col-12 col-md-6">
                                            <az-input   
                                                type="money"
                                                sizing="sm"
                                                label="Pago"
                                                v-model="edicao_valor.reembolso.dc_valor_pago" />
                                        </div>
                                        <div class="col col-12 col-md-6">
                                            <az-input   
                                                type="money"
                                                sizing="sm"
                                                label="Juros"
                                                v-model="edicao_valor.reembolso.dc_valor_juros" />
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col col-12 col-md-6">
                                            <az-input   
                                                type="money"
                                                sizing="sm"
                                                label="Desconto"
                                                v-model="edicao_valor.reembolso.dc_valor_desconto" />
                                        </div>
                                        <div class="col col-12 col-md-6">
                                            <az-input   
                                                type="money"
                                                sizing="sm"
                                                label="Recurso"
                                                v-model="edicao_valor.reembolso.dc_valor_recurso" />
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col col-12 col-md-6">
                                            <az-input   
                                                type="money"
                                                sizing="sm"
                                                label="Inadimplente"
                                                v-model="edicao_valor.reembolso.dc_valor_inadimplente" />
                                        </div>
                                    </div>

                                    <az-input   
                                        label="Observações"
                                        type="textarea"
                                        rows="4"
                                        v-model="edicao_valor.reembolso.st_observacoes" />

                                </template>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                            <az-submit @click="atualizar_valor_reembolso()">Atualizar</az-submit>
                        </div>
                    </div>
                </div>
            </div>    

            <amostras ref="amostras" :viewonly="true" /> 
            <validar-integracao ref="integra" @refresh="load()" />   

            <div id="print-espelho-atendimento" class="d-none d-print-block" v-if="espelho">
                <espelho-atendimento :dados="espelho" :prazo="false" :sem_login="true" :reembolso="true" />    
            </div>

            <!-- Modal de Carregamento... -->
            <div class="modal fade" id="loadingModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body">
                            <az-loading class="my-3" msg="Aguarde..." />
                        </div>
                    </div>
                </div>
            </div>

        </template>

        <reembolso-devolucao ref="devol" @refresh="load()" />

    </div>
</template>

<script>
import * as moment from "moment";
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzLoading from '../../util/AzLoading.vue';
import CelulaDadosPaciente from "../../shared/table/CelulaDadosPaciente.vue";
import CelulaDadosProcedimento from "../../shared/table/CelulaDadosProcedimento.vue";
import RegistrarContatos from '../../shared/RegistrarContatos.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import LaboratorioEtiqueta from '../recepcao/LaboratorioEtiqueta.vue';
import Amostras from '../laboratorio/Amostras.vue';
import EspelhoAtendimento from '../recepcao/EspelhoAtendimento.vue';
import NotaFiscalStatus from "../../modulos/financeiro/NotaFiscalStatus.vue";
import AzSubTitle from '../../util/AzSubTitle.vue';
import ValidarIntegracao from './ValidarIntegracao.vue';
import LoginEnviado from './LoginEnviado.vue';
import ReembolsoDevolucao from './ReembolsoDevolucao.vue';

import { subscribe, unSubscribe } from "../../../service/Notify";

export default {
    data () { 
        return {
            dados: null, 
            from: this.$util.hoje(),
            to: this.$util.hoje(),
            filtro: { 
                id_fila_lead: this.$util.getCookie('crm-fila'), 
                id_unidade_operacao: "", 
                id_contato_status: "", 
                inicio: "",
                fim: "",
                periodo: "do",
                semana: "",
                mes: "", 
                paciente: "", 
                id_operadora:  "", 
                id_medico: "", 
                tipo_data: "", 
                com_nota: "",
                integrados: "", 
                filtro_valor: "", 
                por_grupo: false, 
                procedimento: "", 
                op_filtro: "PAC",
            },
            pode_lote: false, 
            ordem_items: "", 
            filas: [], 
            search: "",
            laudo: null, 
            lista_status: [], 
            novo_contato: null, 
            edicao: null, 
            validate: false, 
            canceltoken: null, 
            page: 1, 
            contadores: [], 
            acao_anexar: false, 
            edicao_guia: null,
            edicao_valor: null, 
            espelho: null, 

            exibir_senha: false, 

            model_type: "marcacao",
            model_id: null, 
            model_arquivos: null, 

            canal: null, 
            ja_buscou: false, 

            por_grupo: false, 
        }
    },

    props: ['aba'], 

    components: { 
        AzInput,
        AzEmptyState, 
        CelulaDadosPaciente, 
        CelulaDadosProcedimento,
        AzPeriodo, 
        RegistrarContatos, 
        AzFileUpload, 
        PrintExport, 
        CabecalhoGenerico, 
        AzSubmit,
        LaboratorioEtiqueta,
        Amostras,
        EspelhoAtendimento, 
        AzLoading, 
        NotaFiscalStatus, 
        AzSubTitle, 
        ValidarIntegracao, 
        LoginEnviado,
        ReembolsoDevolucao, 
    },

    watch: { 
        filtro: { 
            handler: function () {
                if ( !this.filtro.id_fila_lead ) 
                    return;

                // this.load ();
            },
            deep: true,
            immediate: true
        }
    },

    computed: { 
        tem_integrado: function () { 
            if ( !this.lista || !this.lista.length )
                return false;

            return this.lista.find(item => item.marcacao && item.marcacao.st_id_externo && item.marcacao.st_id_externo.indexOf(':') > 0)
                ? true
                : false;
        },

        origem: function () { 
            return window.redir;
        },

        graph_options: function () { 
            return { 
                scales: { 
                    xAxes: [{ 
                        stacked: true, 
                        barThickness: 16, 
                        maxBarThickness: 24,
                        ticks: {
                            callback: (value) => {
                                let show = this.$util.formatMoeda(value);
                                return show.substr(0,show.length - 3);
                            }
                        }
                    }], 
                    yAxes: [{ 
                        stacked: true,
                        barThickness: 16, 
                        maxBarThickness: 24,
                    }] 
                } 
            };
        },

        vazio: function () { 
            if ( this.aba == 'visao' ) { 
                return !( this.contadores && this.contadores.length ) 
            } else { 
                return !( this.lista && this.lista.length ) 
            }
        },

        is_labs: function () { 
            return window.redir == 'labs' || window.redir == 'teste';
        },

        nfl: function () { 
            if ( this.edicao_guia.item.marcacao.unidade_operacao &&
                this.edicao_guia.item.marcacao.unidade_operacao.fl_nota_fiscal &&
                this.edicao_guia.item.marcacao.atendimento.nota_fiscal_link && 
                this.edicao_guia.item.fl_reembolso ) { 

                return this.edicao_guia.item.marcacao.atendimento.nota_fiscal_link;

            }

            return null;
        },

        lista: function () { 
            if ( !this.dados )
                return [];

            let items;

            if ( this.search && this.search.substr(0,1) == '#' && !isNaN(this.search.substr(1)) ) {

                items = this.dados.data.filter(item => !this.filtro.id_status_laudo || item.id_status_laudo == this.filtro.id_status_laudo)
                    .filter(item => item.id_atendimento == this.search.substr(1) );    

            } else { 

                let reg = this.$util.getregex(this.search);

                /*
                .filter(item => ( !this.filtro.id_contato_status || 
                            ( !item.contatos.length && this.filtro.id_contato_status == 'R' ) ||
                            ( item.contatos.length && item.contatos[0].id_contato_status == this.filtro.id_contato_status)))
                */

                items = this.dados.data.filter(item => !this.filtro.id_status_laudo || item.id_status_laudo == this.filtro.id_status_laudo)
                        .filter(item => ( !this.search || reg.test(JSON.stringify(item)) ));

            }

            switch (this.ordem_items) {
                case 'A':
                    items = _.orderBy(items, item => item.paciente.st_nome);
                    break;

                case 'N':
                    items = _.orderBy(items, item => item.marcacao.id_atendimento);
                    break;

                case 'V': 
                    items = _.orderBy(items, item => item.total_items ? parseFloat(item.total_items.valor_total) : 0);
                    break;
            }

            return items;

        },

        total_edicao: function () { 
            if ( !this.edicao || !this.edicao.atendimento_procedimentos )
                return 0;

            return this.edicao.atendimento_procedimentos.reduce((total, carry) => { 
                return total + parseFloat(carry.cd_valor_total);
            }, 0);
        },

        possuiNF: function() {
            const nfLinks = _.get(this.edicao_guia, "item.marcacao.atendimento.nota_fiscal_links");

            return (
                nfLinks != undefined &&
                Array.isArray(nfLinks) &&
                nfLinks.length > 0
            );
        },

        listaNf: function() {
            if (!this.possuiNF) return [];

            return this.edicao_guia.item.marcacao.atendimento.nota_fiscal_links;
        },

        lista_status_edicao: function () { 
            return this.lista_status 
                ? this.lista_status.filter(item => item.tem_acesso) 
                : [];
        },

        lista_status_block_edicao: function () { 
            return this.lista_status 
                ? this.lista_status.filter(item => !item.tem_acesso_origem && !isNaN(item.id_contato_status))
                    .map(item => item.id_contato_status) 
                : [];
        },

        dados_exportacao: function () { 
            if ( this.aba == 'visao' ) { 
                return [];
            }

            return this.lista.map(item => { 

                return { 
                    data: item.dt_inicio, 
                    status: item.contatos.length
                        ? item.contatos[0].contato_status.search
                        : 'Registrado', 
                    id_atendimento: item.id_atendimento,
                    paciente: item.paciente.st_nome, 
                    plano: item.plano
                        ? item.plano.search
                        : '?', 
                    unidade: ( item.marcacao && item.marcacao.unidade_operacao )
                        ? item.marcacao.unidade_operacao.st_sigla
                        : '?',
                    procedimento: ( item.marcacao && item.marcacao.procedimento )
                        ? item.marcacao.procedimento.search
                        : '?',
                    medico: ( item.marcacao && item.marcacao.medico )
                        ? item.marcacao.medico.st_nome_exibicao
                        : '?', 
                    nf: item.guias.map(guia => guia.st_numero_interno).join(', '),
                    protocolo: item.guias.map(guia => guia.st_numero).join(', '),
                    valor: ( item.total_items && item.total_items.valor_total > 0 ) 
                        ? this.$util.formatMoeda(item.total_items.valor_total) 
                        : 0,
                    creditado: ( item.reembolso && item.reembolso.dc_valor_creditado ) 
                        ? this.$util.formatMoeda(item.reembolso.dc_valor_creditado) 
                        : 0, 
                    pago: ( item.reembolso && item.reembolso.dc_valor_pago ) 
                        ? this.$util.formatMoeda(item.reembolso.dc_valor_pago - ( item.reembolso.dc_valor_devolvido ? item.reembolso.dc_valor_devolvido : 0 )) 
                        : 0,
                    devolvido: ( item.reembolso && item.reembolso.dc_valor_devolvido )
                        ? this.$util.formatMoeda(item.reembolso.dc_valor_devolvido)
                        : 0,
                    juros: ( item.reembolso && item.reembolso.dc_valor_juros )
                        ? this.$util.formatMoeda(item.reembolso.dc_valor_juros)
                        : 0,
                    desconto: ( item.reembolso && item.reembolso.dc_valor_desconto )
                        ? this.$util.formatMoeda(item.reembolso.dc_valor_desconto)
                        : 0,
                    recurso: ( item.reembolso && item.reembolso.dc_valor_recurso )
                        ? this.$util.formatMoeda(item.reembolso.dc_valor_recurso)
                        : 0,
                    inadimplente: ( item.reembolso && item.reembolso.dc_valor_inadimplente )
                        ? this.$util.formatMoeda(item.reembolso.dc_valor_inadimplente)
                        : 0,
                    data_de_emissao: _.get(item, 'reembolso.guia.guia_fatura.fatura_envio.lancamento.dt_emissao')
                        ? this.$util.getFormatDate(_.get(item, 'reembolso.guia.guia_fatura.fatura_envio.lancamento.dt_emissao'))
                        : '',
                    data_de_referencia: _.get(item, 'contatos.0.dt_referencia')
                        ? this.$util.getFormatDate(_.get(item, 'contatos.0.dt_referencia'))
                        : '',
                    data_do_credito: ( item.reembolso && item.reembolso.dc_valor_creditado > 0 && item.reembolso.dt_creditado )
                        ? this.$util.getFormatDate(item.reembolso.dt_creditado)
                        : '',
                };

            });
        },
    },

    methods: { 
        editar_lancamento (lanc) { 
            this.$refs.devol.editar(lanc);
        },

        registrar_devolucao (item) { 
            this.$refs.devol.incluir(item);
        },

        integrar_agenda_klingo(item) { 
            this.$util.atualizar(this, { 
                service: 'terceiros',
                func: 'integrar_klingo', 
                dados: {
                    lista: [
                        item.marcacao.id_marcacao
                    ]
                },
            });
        },

        integrar_reembolsos_klingo () { 
            this.$util.atualizar(this, { 
                service: 'terceiros',
                func: 'integrar_reembolsos_klingo', 
                dados: {
                    ids: this.lista.filter(item => item.marcacao && item.marcacao.st_id_externo && item.marcacao.st_id_externo.indexOf(':') > 0)
                        .map(item => item.marcacao.id_marcacao)
                },
            });
        },

        integrar_reembolso_klingo (item) { 
            this.$util.atualizar(this, { 
                service: 'terceiros',
                func: 'integrar_reembolso_klingo', 
                dados: { 
                    id_marcacao: item.marcacao.id_marcacao, 
                },
            });
        },

        is_mes_atual(nf) {
            if(nf && nf.dt_competencia) {
                const competencia = moment(nf.dt_competencia, "YYYY-MM-DD");
                const hj = moment();

                return competencia.month() == hj.month();
            }

            return true;
        },
        cancelar_baixa (baixa) { 
            if ( !confirm('Confirma cancelar a baixa selecionada?') ) 
                return;

            this.$util.atualizar(this, { 
                service: 'financeiro',
                func: 'cancelar_baixa', 
                dados: { 
                    id_baixa: baixa.id_baixa, 
                    st_motivo_cancelamento: 'Cancelamento no reembolso',
                },
                modal: 'valorReembolsoModal',
                reload: true, 
            }); 
        },

        formatMoedaGrafico(value) { 
            let show = this.$util.formatMoeda(value);
            return show.substr(0,show.length - 3);
        },

        bootstrap_color(name) { 
            switch (name) {
                case 'primary': return '#cce5ff';
                case 'secondary': return '#e2e3e5';
                case 'success': return '#d4edda';
                case 'danger': return '#f8d7da';
                case 'warning': return '#fff3cd';
                case 'info': return '#d1ecf1';
                case 'dark': return '#c6c8ca';
                default: return '#f7f7f7';
            }
        },

        info_grafico (campo) { 
            const limite = 7;
            
            let info = _.orderBy(
                _.cloneDeep(this.contadores),
                campo,
                'desc'
            );

            if ( info.length > limite ) { 

                let outros = _.slice(info, limite);

                let outro = { 
                    status: 'Outros',
                    color: 'dark', 
                };

                outro[campo] = outros.reduce((total, carry) => { 
                    return total + carry[campo];
                }, 0);

                info = _.slice(info, 0, limite);
                info.push(outro);

            }
                    
            let grafico = {
				labels: _.map(info, (item) => ( this.por_grupo ? item.grupo : item.status )),
				datasets: [
					{
						label: 'Valor',
                        backgroundColor: _.map(info, (item) => this.bootstrap_color(item.color)),
                        borderColor: '#AAAAAA',
                        fill: true, 
						data: _.map(info, (item) => item[campo])
					}
				]
            };
            
            return grafico;
        },

        abrir(aba) { 
            if ( aba != this.aba ) { 
              this.$router.push({ path: '/reembolso/' + aba });
            }

            this.set_bread(aba);

            this.ja_buscou = false;
        },

        set_bread (aba = null) { 

            if ( !aba )
                aba = this.aba;

            if ( aba == 'visao' ) { 

                this.$store.commit("setBreadcrumb", [
                    { name: "Reembolso", path: "/reembolso/visao" },
                    { name: "Visão Geral", path: "/reembolso/visao" },
                ]);

            } else if ( aba == 'login' ) { 

                this.$store.commit("setBreadcrumb", [
                    { name: "Reembolso", path: "/reembolso/reembolsos" }, 
                    { name: "Logins", path: "/reembolso/logins" }
                ]);

            } else { 

                this.$store.commit("setBreadcrumb", [
                    { name: "Reembolso", path: "/reembolso/visao" },
                    { name: "Reembolsos", path: "/reembolso/reembolsos" },
                ]);

            }

        },

        verificar_status_rpa (item) { 

            const canal = window.redir + '-rpa-st-' + this.$store.state.user.id_usuario;
            
            this.$util.atualizar(this, { 
                service: 'reembolsos',
                func: 'rpa_status', 
                dados: { 
                    id_atendimento: item.id_atendimento,
                    canal: canal, 
                },
                toast: true, 
                msg: 'Status Requisitado.',
                callback: () => { 
                    if ( !this.canal ) { 

                        this.canal = canal;

                        subscribe(window.redir, this.canal, subres => { 
                            this.$toast.add({
                                severity: "info",
                                summary: "Retorno",
                                detail: ( subres && subres.data ) ? subres.data : 'Processamento concluído.',
                                life: 20000
                            });

                            this.load();

                            //unSubscribe(window.redir, this.canal);
                            //this.canal = null;
                        });

                    }

                }
            });

        },

        atualizar_valor_reembolso () { 
            this.$util.atualizar(this, { 
                service: 'reembolsos',
                func: 'store',
                dados: { 
                    ...this.edicao_valor.reembolso,
                    nova_baixa: this.edicao_valor.registrar_nova_baixa
                        ? this.edicao_valor.nova_baixa
                        : null, 
                },
                modal: 'valorReembolsoModal',
                reload: true, 
            });
        },

        editar_valor (item) { 
            this.edicao_valor = null;

            this.$nextTick(() => { 
                let edicao = _.cloneDeep(item);

                if ( !edicao.reembolso ) { 

                    edicao.reembolso = { 
                        pago: false, 
                        id_atendimento: edicao.id_atendimento, 
                        dc_valor_pago: 0,
                        dc_valor_desconto: 0,
                        dc_valor_recurso: 0, 
                        st_observacoes: "", 
                    };

                }

                edicao.reembolso.total = edicao.total_items.valor_total;
                edicao.guia = null;
                edicao.lancamento = null;
                edicao.registrar_nova_baixa = false; 
                edicao.nova_baixa = { 
                    id_forma_pagamento: "", 
                    dc_valor: 0,
                    dc_descontos: 0, 
                    dc_multa_juros: 0, 
                };
                
                this.edicao_valor = edicao;

                if ( ( edicao.fl_reembolso == 2 || edicao.fl_reembolso == 3 ) && edicao.guias && edicao.guias.length == 1 ) { 
                    
                    this.$util.load(this, { 
                        service: 'guias',
                        func: 'show',
                        parms: { 
                            id: edicao.guias[0].id_guia, 
                            reembolso: true, 
                        },
                        loadTo: res => { 
                            this.edicao_valor.guia = res;
                            this.edicao_valor.lancamento = _.get(res, 'guia_fatura.fatura.fatura_envio.lancamento');
                            this.edicao_valor.nova_baixa.id_lancamento = _.get(res, 'guia_fatura.fatura.fatura_envio.id_lancamento');

                            edicao.nova_baixa.id_forma_pagamento = this.edicao_valor.lancamento.id_forma_pagamento;
                        }
                    });

                }

                $('#valorReembolsoModal').modal('show');
            });
        },

        verificar_status (item) { 
            item.rpa_status = 'Verificando...';
            this.$forceUpdate();

            this.$util.atualizar(this, { 
                service: 'reembolsos', 
                func: 'rpa_status',
                dados: { 
                    id_atendimento: item.id_atendimento,
                },
                callback: res => { 
                    item.rpa_status = res;
                },
            });
        },

        filtrar_status (contador) { 
            if ( !contador ) { 
                contador = { 
                    id_contato_status: 'R', 
                };
            }

            this.abrir('reembolsos');

            if ( this.filtro.id_contato_status == contador.id_contato_status ) { 
                this.filtro.id_contato_status = "";    
                
                if ( !contador.id_contato_status ) { 
                    return;
                }
            } else { 
                this.filtro.id_contato_status = contador.id_contato_status;
            }

            if ( this.aba == 'reembolsos' ) { 
                this.$nextTick(() => { 
                    this.load();
                });
            }

            // 
        },

        totalizar (lista, campo) { 
            return lista.reduce((total, carry) => { 
                return total + carry[campo];
            }, 0);
        },

        enviar_espelho(item) { 
            this.$util.atualizar(this, { 
                service: 'marcacoes',
                func: 'enviar_espelho',
                dados: { 
                    id_atendimento: item.id_atendimento, 
                }
            });
        },

        abrir_atendimento(item) { 
            this.$util.abrir_atendimento(this, item.id_atendimento);
        },

        gerarNF: function() {
            if (!confirm("Deseja gerar a Nota Fiscal de Serviço?"))
                return;

            this.$util.atualizar(this, {
                service: "nota_fiscal_servico",
                func: "gerar_nf_atendimento",
                toast: true,
                redir_api: true, 
                dados: {
                    id_atendimento: this.edicao_guia.item.id_atendimento,
                },
                modal: 'edicaoGuiaModal',
                reload: true, 
            });
        },

        getStatusClass: function(status) {
            switch (status) {
                case "1":
                    return "text-info";
                case "2":
                    return "text-primary";
                case "3":
                    return "text-warning";
                case "4":
                    return "text-success";
                case "5":
                    return "text-danger";

                default:
                    return "text-info";
            }
        },
        
        imprimir_nf(item) {
            // if ( !confirm('Deseja realmente enviar a Nota Fiscal por e-mail para o Tomador?') )
            //     return;

            $('#loadingModal').modal('show');

            this.$util.atualizar(this, {
                service: "nota_fiscal_servico",
                func: "imprimir_nf",
                toast: true,
                dados: {
                    id_nota_fiscal_servico: item.marcacao.atendimento.nota_fiscal_link.nota_fiscal_servico.id_nota_fiscal_servico
                },
                callback: (res) => {
                    $('#loadingModal').modal('hide');
                    
                    if (res && res.url) {
                         window.open(res.url, '_blank').focus();
                    }
                },
                final: () => { 
                    $('#loadingModal').modal('hide');
                }
            });
        },

        imprimir_espelho (item) { 
            $('#loadingModal').modal('show');

            this.espelho = null;

            this.$util.loadItem(this, { 
                service: 'marcacoes',
                func: 'show',
                parms: { 
                    id: item.marcacao.id_marcacao,
                    buscar_outras: true,
                    guia_tiss: true,
                }
            })
            .then(res => { 
                this.espelho = res;

                this.$nextTick(() => { 
                    this.$htmlToPaper('print-espelho-atendimento', null, () => {
                        console.log("Printing");
                    });
                });
            })
            .finally(() => { 
                $('#loadingModal').modal('hide');
            });
        },

        cancelar_lancamento () { 
            if ( !confirm('Confirma cancelar o lançamento no contas a receber?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'guias',
                func: 'cancelar_lancamento_reembolso',
                dados: { 
                    id_guia: this.edicao_guia.guia.id_guia
                },
                modal: 'edicaoGuiaModal',
                reload: true, 
            });
        },

        atualizar_guia () { 
            this.$util.atualizar(this, { 
                service: 'guias',
                func: 'store_reembolso_numero',
                dados: this.edicao_guia.guia,
                modal: 'edicaoGuiaModal',
                reload: true, 
            });
        },

        editar_guia (item, guia) { 
            // let clone_guia = _.cloneDeep(guia);
            // clone_guia.gerar_lanc = false;

            this.validate = false;

            this.edicao_guia = { 
                item: item,
                guia: null, // clone_guia, 
            };

            $('#edicaoGuiaModal').modal('show');

            this.$util.load(this, { 
                service: 'guias',
                func: 'show',
                parms: { 
                    id: guia.id_guia, 
                    reembolso: true, 
                },
                loadTo: res => { 
                    res.gerar_lanc = false;
                    this.edicao_guia.guia = res;
                }
            });

        },
        // Arquivos
        abrir_anexar_arquivo(item, model = null) { 
            this.model_type = model ? model : 'marcacao';

            if ( this.model_type == 'marcacao' ) { 
                this.model_id = item.marcacao.id_marcacao;
                this.model_arquivos = item.marcacao;
            } else if ( this.model_type == 'pessoa' ) { 
                this.model_id = item.marcacao.id_paciente;
                this.model_arquivos = item.paciente;
            } else { 
                this.model_id = item.marcacao.autorizacao.id_solicitacao_autorizacao;
                this.model_arquivos = item.marcacao.autorizacao;
            }

            this.edicao = item;
                
            this.acao_anexar = true;

            if ( this.model_arquivos.arquivos && this.model_arquivos.arquivos.length && !this.model_arquivos.arquivos.find(arq => arq.arquivo) ) { 
                this.carregar_arquivos(true);
                return;
            }

            this.$nextTick(() => { 
                this.$refs.upload.abrir();
            });
        },

        carregar_arquivos (abrir = false) { 

            this.$store.commit('loading', true);

            this.$util.loadItem(this, { 
                service: 'arquivos',
                func: 'links',
                parms: { 
                    id: this.model_id, 
                    type: this.model_type,
                }
            })
            .then(res => { 
                this.model_arquivos.arquivos = res;

                if ( abrir ) { 
                    this.$nextTick(() => { 
                    this.$refs.upload.abrir();
                    });
                }
            })
            .finally(() => { 
                this.$store.commit('loading', false);
            });

        },

        cor_item (item) { 
            return ( item && item.contatos.length && item.contatos[0].contato_status.st_color ) 
                ? item.contatos[0].contato_status.st_color 
                : 'secondary';
        },

        abrir_contatos (item = null) { 
            this.edicao = null; 
            // $('#loadingModal').modal('show');

            this.$refs.regcontatos.abrir();

            if ( !item ) { 
                let fl_reembolso = _.get(this.lista, '0.fl_reembolso');
                let lista = this.lista.filter(item => item.fl_reembolso == fl_reembolso);

                this.edicao = { 
                    nome_paciente: 'Gerar para ' + lista.length + ( lista.length == 1 ? ' registro' : ' registros' ), 
                    model: { 
                        type: ( fl_reembolso == 2 || fl_reembolso == 3 ) ? 'guia' : 'atendimento', 
                        id: -1, 
                    }, 
                    id_contato_status: "",
                    st_observacoes: "", 
                    lote: true, 
                    contatos: [], 
                    lista: lista.map(item => { 
                        return { 
                            type: ( fl_reembolso == 2 || fl_reembolso == 3 ) ? 'guia' : 'atendimento',
                            id: ( item.fl_reembolso == 2 || item.fl_reembolso == 3 ) ? item.id_guia : item.id_atendimento,
                        };
                    }),
                };

                this.$refs.regcontatos.editar(this.edicao);
                
                return;
            }

            this.$store.commit('loading', true);

            this.$nextTick(() => { 

                this.$util.loadItem(this, { 
                    service: 'reembolsos',
                    func: 'show',
                    parms: {
                        id_atendimento: item.id_atendimento, 
                        id_guia: item.id_guia, 
                    },
                })
                .then(res => { 
                    res.rpa_status = "";

                    res.pago = res.reembolso ? true : false;

                    if ( !res.reembolso ) { 
                        res.reembolso = { 
                            dc_valor_pago: 0,
                            dc_valor_desconto: 0,
                            dc_valor_recurso: 0, 
                        };
                    }

                    this.edicao = res;

                    if ( item.fl_reembolso == 2 || item.fl_reembolso == 3 ) { 

                        this.edicao.model = { 
                            type: 'guia',
                            id: item.id_guia, 
                        };    

                    } else { 

                        this.edicao.model = { 
                            type: 'atendimento',
                            id: this.edicao.id_atendimento, 
                        };    

                    }

                    this.edicao.nome_paciente = this.edicao.paciente.st_nome;
                    this.$refs.regcontatos.editar(this.edicao);
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

            });

            /*
            this.edicao = _.cloneDeep(item);

            this.edicao.model = { 
                type: 'atendimento',
                id: this.edicao.id_atendimento, 
            };

            this.edicao.nome_paciente = this.edicao.paciente.st_nome;

            this.$util.load

            this.$refs.regcontatos.editar(this.edicao);
            */
        },

        paginar (page) {
            this.page = page;
            this.load();
        },

        agendar (item) { 
            $('[data-toggle="tooltip"]').tooltip("dispose");
            $('.modal').modal('hide');

            this.$nextTick(() => { 
                this.$router.push({
                    name: "call-center",
                    params: { id_requisicao_procedimento: item.id_requisicao_procedimento }
                });
            });
        },

        load(page = null, aba = null) { 
            if ( page )
                this.page = page;

            if ( this.canceltoken ) {
                this.canceltoken.cancel('#BC#');
            }

            this.canceltoken = this.axios.CancelToken.source();

            this.ja_buscou = true;
            this.pode_lote = false;
            
            this.$util.load(this, { 
                service: 'reembolsos',
                func: 'index',
                canceltoken: this.canceltoken.token,
                parms: { 
                    ...this.filtro, 
                    search: this.search, 
                    page: this.page,
                    size: 100, 
                    aba: aba ? aba : this.aba, 
                },
                loadTo: res => { 
                    this.dados = res.lista;
                    this.lista_status = res.lista_status;
                    this.contadores = res.contadores; 
                    this.por_grupo = res.por_grupo; 

                    if ( this.dados.data.length && this.filtro.id_contato_status ) { 
                        this.pode_lote = true;

                        if ( this.dados.data.find(item => item.fl_reembolso != _.get(this.dados, 'data.0.fl_reembolso')) ) { 
                            this.pode_lote = false;
                        } else if ( this.dados.data.find(item => _.get(item, 'reembolso.pago')) ) {  
                            this.pode_lote = false;
                        }
                    }
                }
            });
        }
    },

    beforeDestroy() { 
        if ( this.canal ) { 
            unSubscribe(window.redir, this.canal);
            this.canal = null;
        }
    },

    mounted() { 

        this.set_bread();
        // this.load();

        if ( this.$route.params.search ) { 

            const ids = this.$route.params.search.match(/#[0-9]+/gi);

            if ( ids ) { 
                this.search = ids[0];
                this.load();
            }

        }

    }
    
}
</script>

